import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, TextField, TextareaAutosize } from "@mui/material";
import { useUser } from "./UserProvider";

export function Survey({open, onClose}) {
    

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle></DialogTitle>
            <DialogContent>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 30,
                    justifyContent: 'center',
                    width: 400,
                    padding: "20px 20px 20px",
                }}>
                    <p>    
                        Why did you sign up for MakeMyBrand?
                    </p>
                    <TextField label="What can this product do for you?" />
                    <Button variant="outlined" color="primary">Submit</Button>
                </div>
            </DialogContent>

        </Dialog>
    )
}